<template>
  <div class="popup">
    <div class="popup__overlay"></div>

    <div class="popup__container">
      <h1>{{ content.title }}</h1>

      <img class="popup__image" src="../../assets/svg/piggy-bank.svg" />

      <p class="popup__text"> {{ content.text }}</p>

      <Button
        class="button button--secondary button--remove-btm-margin"
        :msg="content.link_msg"
        :link="content.link"
      />
    </div>
  </div>
</template>

<script>
import Button from './Button'

export default {
  name: 'Popup',
  components: { Button },
  props: [ 'content' ]
}
</script>

<style lang="scss" scoped>
.popup {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 100; // Place over everything!

  &__overlay {
    position: absolute;
    background-color: rgba(0, 0, 0, .5);
    height: inherit;
    width: inherit;
  }

  &__container {
    width: 90%;
    padding: 1rem;
    background-color: white;
    z-index: 1; // Place over overlay
    border-radius: $borderRadius;
    text-align: center;
    margin-top: 10%;
  }

  &__image {
    margin: 1.5rem 0;
  }

  &__text {
    color: $green;
  }

  @include breakpoints(medium) {
    &__container {
      width: 50%;
      padding: 2rem;
    }
  }
}
</style>